import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { SetupApprovalEditPageRoutingModule } from './setup-approval-edit-routing.module';

import { SetupApprovalEditPage } from './setup-approval-edit.page';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { IonicSelectableModule } from 'ionic-selectable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SetupApprovalEditPageRoutingModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    IonicSelectableModule
  ],
  declarations: [SetupApprovalEditPage]
})
export class SetupApprovalEditPageModule {}
